(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Inicializa todas las barras presentes (normalmente una).
    document.querySelectorAll('[data-ia-scta]').forEach(initStickyCTA);

    function initStickyCTA(bar) {
      var threshold = (parseFloat(bar.dataset.threshold) || 25) / 100; // 0.25
      var targetSel = bar.dataset.target;
      var action    = bar.dataset.action || 'scroll';
      var target    = targetSel ? document.querySelector(targetSel) : null;
      var force     = bar.dataset.force === 'true'; // modo prueba: mostrar siempre
      var link      = bar.dataset.link || '';       // destino en modo enlace
      var showOnLoad = bar.dataset.onload === 'true'; // mostrar al entrar, sin scroll

      var targetVisible = false; // ¿está el botón de compra en pantalla?

      // 1) Observa el botón de compra principal para ocultar la barra cuando aparece.
      if (target && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          targetVisible = entries[0].isIntersecting;
          update();
        }, { threshold: 0.35 });
        io.observe(target);
      }

      // 2) ¿Ha desplazado el usuario el % configurado?
      function scrolledEnough() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (docHeight <= 0) return false;
        return (scrollTop / docHeight) >= threshold;
      }

      // Muestra/oculta según ambas condiciones.
      function update() {
        if (force) { bar.classList.add('is-visible'); return; } // modo prueba
        // En modo "mostrar al entrar" ignoramos el umbral de scroll.
        var passedScroll = showOnLoad ? true : scrolledEnough();
        var show = passedScroll && !targetVisible;
        bar.classList.toggle('is-visible', show);
      }

      // Scroll optimizado con requestAnimationFrame (rendimiento móvil).
      var ticking = false;
      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(function () { update(); ticking = false; });
          ticking = true;
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      // Entrada: si es "mostrar al entrar", pequeño retardo para que deslice
      // con elegancia en lugar de aparecer de golpe (sensación premium).
      if (showOnLoad) {
        setTimeout(update, 400);
      } else {
        update();
      }

      // 3) Acción del botón: enlace directo, scroll suave o click al botón real.
      var btn = bar.querySelector('[data-ia-scta-button]');
      if (btn) {
        btn.addEventListener('click', function (e) {
          if (action === 'link') {
            // Modo Home: lleva directo a la ruta de compra del Pack.
            if (link) window.location.href = link;
            return;
          }
          if (!target) return; // sin destino, no hace nada raro
          e.preventDefault();
          if (action === 'click') {
            // Ejecuta exactamente la misma acción de compra existente.
            target.click();
          } else {
            // Desplazamiento suave hasta el botón principal.
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
